export const environment = {
  production: false,
  apiUrl: 'https://mac-api.staging.designlogica.dev',

  // Staged-rollout feature flags. Flip these booleans to show/hide
  // top-level features in the UI and at the route layer.
  // Anything not listed here defaults to enabled.
  features: {
    organizations: true,
    people: true,
    parentsCarers: true,
    cases: true,
    interactions: true,
    wt4c: true,
    adminReference: true,
    adminUsers: true,
    adminAudit: true,
    adminCustomFields: true,
  } as Record<string, boolean>,
};
